import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { padding, system } from 'styled-system';

import sx from '../../internal/styles/sx';
import { TableBodyProps } from './types';

const TableBody = styled('tbody', { shouldForwardProp })<TableBodyProps>(
  {
    boxSizing: 'border-box',
  },
  padding,
  system({
    fontSize: {
      property: 'fontSize',
      scale: 'fontSizes',
    },
  }),
  sx
);

export default TableBody;
